import sectionItemsGrid02Css from '../css-snippets/section-items-grid-02';

const html = `
<style>${sectionItemsGrid02Css}</style>
<div
  id="items-grid-section-unique-id"
  data-id="unique-id"
  class="items-grid-02-wrapper"
  data-attribute="wrapper-container"
  data-background-color="#F7F8F9"
  data-text-color="#000000"
  data-top-padding="true"
  data-bottom-padding="true"
  style="
    background-color: #F7F8F9;
    --text-color: #000000;
  "
>
  <div data-attribute="wrapper-content" class="items-grid-02-content" data-container-full-width="true">
    <div data-attribute="title-content" class="items-grid-02-header">
      <h2 style="text-align: center">
        <span><strong>WHAT'S IN THE BOX</strong></span>
      </h2>
    </div>
    <div
      data-attribute="list-item"
      class="items-grid-02-list"
      data-items-per-row-mobile="2"
      data-items-per-row-desktop="5"
      style="
        --items-per-row-mobile: 2;
        --items-per-row-desktop: 5;
      "
    >
      <div data-attribute="item" class="items-grid-02-item">
        <div class="items-grid-02-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/03/18/image-69ba52f71c75af32c1da542d.avif?w=50&h=50&q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="items-grid-02-item-text">
          <p style="text-align: center">UPRIGHT GO S</p>
        </div>
      </div>

      <div data-attribute="item" class="items-grid-02-item">
        <div class="items-grid-02-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/03/18/image-69ba530ac376d19737ad4024.avif?w=50&h=50&q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="items-grid-02-item-text">
          <p style="text-align: center">Travel Case</p>
        </div>
      </div>

      <div data-attribute="item" class="items-grid-02-item">
        <div class="items-grid-02-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/03/18/image-69ba531726432f50df25354b.avif?w=50&h=50&q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="items-grid-02-item-text">
          <p style="text-align: center">USB-C Charging Cable</p>
        </div>
      </div>

      <div data-attribute="item" class="items-grid-02-item">
        <div class="items-grid-02-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/03/18/image-69ba53260a1d2e96176267d4.avif?w=50&h=50&q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="items-grid-02-item-text">
          <p style="text-align: center">Adhesive Removal Tool</p>
        </div>
      </div>

      <div data-attribute="item" class="items-grid-02-item">
        <div class="items-grid-02-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/03/18/image-69ba53372054af02a060b193.avif?w=50&h=50&q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="items-grid-02-item-text">
          <p style="text-align: center">5 Reusable<br/>Silicon Adhesives</p>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
